// ============================================================================
// FICHIER GÉNÉRÉ — ne pas modifier à la main.
//
// Les sous-classes de la NAF rév. 2 et de la NAF 2025 et leurs libellés, lus dans les fichiers de
// l’INSEE archivés sous `reference/naf/` (provenance dans son README). `scripts/audit-naf.mjs` re-dérive
// ce fichier au lint et refuse toute différence, retouche à la main comprise.
//
// Régénérer : node scripts/build-naf.mjs
// ============================================================================

/** NAF rév. 2 — 732 sous-classes, libellés tels que l’INSEE les publie. */
export const NAF_REV2_LABELS: Readonly<Record<string, string>> = {
  "01.11Z": "Culture de céréales (à l'exception du riz), de légumineuses et de graines oléagineuses",
  "01.12Z": "Culture du riz",
  "01.13Z": "Culture de légumes, de melons, de racines et de tubercules",
  "01.14Z": "Culture de la canne à sucre",
  "01.15Z": "Culture du tabac",
  "01.16Z": "Culture de plantes à fibres",
  "01.19Z": "Autres cultures non permanentes",
  "01.21Z": "Culture de la vigne",
  "01.22Z": "Culture de fruits tropicaux et subtropicaux",
  "01.23Z": "Culture d'agrumes",
  "01.24Z": "Culture de fruits à pépins et à noyau",
  "01.25Z": "Culture d'autres fruits d'arbres ou d'arbustes et de fruits à coque",
  "01.26Z": "Culture de fruits oléagineux",
  "01.27Z": "Culture de plantes à boissons",
  "01.28Z": "Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques",
  "01.29Z": "Autres cultures permanentes",
  "01.30Z": "Reproduction de plantes",
  "01.41Z": "Élevage de vaches laitières",
  "01.42Z": "Élevage d'autres bovins et de buffles",
  "01.43Z": "Élevage de chevaux et d'autres équidés",
  "01.44Z": "Élevage de chameaux et d'autres camélidés",
  "01.45Z": "Élevage d'ovins et de caprins",
  "01.46Z": "Élevage de porcins",
  "01.47Z": "Élevage de volailles",
  "01.49Z": "Élevage d'autres animaux",
  "01.50Z": "Culture et élevage associés",
  "01.61Z": "Activités de soutien aux cultures",
  "01.62Z": "Activités de soutien à la production animale",
  "01.63Z": "Traitement primaire des récoltes",
  "01.64Z": "Traitement des semences",
  "01.70Z": "Chasse, piégeage et services annexes",
  "02.10Z": "Sylviculture et autres activités forestières",
  "02.20Z": "Exploitation forestière",
  "02.30Z": "Récolte de produits forestiers non ligneux poussant à l'état sauvage",
  "02.40Z": "Services de soutien à l'exploitation forestière",
  "03.11Z": "Pêche en mer",
  "03.12Z": "Pêche en eau douce",
  "03.21Z": "Aquaculture en mer",
  "03.22Z": "Aquaculture en eau douce",
  "05.10Z": "Extraction de houille",
  "05.20Z": "Extraction de lignite",
  "06.10Z": "Extraction de pétrole brut",
  "06.20Z": "Extraction de gaz naturel",
  "07.10Z": "Extraction de minerais de fer",
  "07.21Z": "Extraction de minerais d'uranium et de thorium",
  "07.29Z": "Extraction d'autres minerais de métaux non ferreux",
  "08.11Z": "Extraction de pierres ornementales et de construction, de calcaire industriel, de gypse, de craie et d'ardoise",
  "08.12Z": "Exploitation de gravières et sablières, extraction d'argiles et de kaolin",
  "08.91Z": "Extraction des minéraux chimiques et d'engrais minéraux",
  "08.92Z": "Extraction de tourbe",
  "08.93Z": "Production de sel",
  "08.99Z": "Autres activités extractives n.c.a.",
  "09.10Z": "Activités de soutien à l'extraction d'hydrocarbures",
  "09.90Z": "Activités de soutien aux autres industries extractives",
  "10.11Z": "Transformation et conservation de la viande de boucherie",
  "10.12Z": "Transformation et conservation de la viande de volaille",
  "10.13A": "Préparation industrielle de produits à base de viande",
  "10.13B": "Charcuterie",
  "10.20Z": "Transformation et conservation de poisson, de crustacés et de mollusques",
  "10.31Z": "Transformation et conservation de pommes de terre",
  "10.32Z": "Préparation de jus de fruits et légumes",
  "10.39A": "Autre transformation et conservation de légumes",
  "10.39B": "Transformation et conservation de fruits",
  "10.41A": "Fabrication d'huiles et graisses brutes",
  "10.41B": "Fabrication d'huiles et graisses raffinées",
  "10.42Z": "Fabrication de margarine et graisses comestibles similaires",
  "10.51A": "Fabrication de lait liquide et de produits frais",
  "10.51B": "Fabrication de beurre",
  "10.51C": "Fabrication de fromage",
  "10.51D": "Fabrication d'autres produits laitiers",
  "10.52Z": "Fabrication de glaces et sorbets",
  "10.61A": "Meunerie",
  "10.61B": "Autres activités du travail des grains",
  "10.62Z": "Fabrication de produits amylacés",
  "10.71A": "Fabrication industrielle de pain et de pâtisserie fraîche",
  "10.71B": "Cuisson de produits de boulangerie",
  "10.71C": "Boulangerie et boulangerie-pâtisserie",
  "10.71D": "Pâtisserie",
  "10.72Z": "Fabrication de biscuits, biscottes et pâtisseries de conservation",
  "10.73Z": "Fabrication de pâtes alimentaires",
  "10.81Z": "Fabrication de sucre",
  "10.82Z": "Fabrication de cacao, chocolat et de produits de confiserie",
  "10.83Z": "Transformation du thé et du café",
  "10.84Z": "Fabrication de condiments et assaisonnements",
  "10.85Z": "Fabrication de plats préparés",
  "10.86Z": "Fabrication d'aliments homogénéisés et diététiques",
  "10.89Z": "Fabrication d'autres produits alimentaires n.c.a.",
  "10.91Z": "Fabrication d'aliments pour animaux de ferme",
  "10.92Z": "Fabrication d'aliments pour animaux de compagnie",
  "11.01Z": "Production de boissons alcooliques distillées",
  "11.02A": "Fabrication de vins effervescents",
  "11.02B": "Vinification",
  "11.03Z": "Fabrication de cidre et de vins de fruits",
  "11.04Z": "Production d'autres boissons fermentées non distillées",
  "11.05Z": "Fabrication de bière",
  "11.06Z": "Fabrication de malt",
  "11.07A": "Industrie des eaux de table",
  "11.07B": "Production de boissons rafraîchissantes",
  "12.00Z": "Fabrication de produits à base de tabac",
  "13.10Z": "Préparation de fibres textiles et filature",
  "13.20Z": "Tissage",
  "13.30Z": "Ennoblissement textile",
  "13.91Z": "Fabrication d'étoffes à mailles",
  "13.92Z": "Fabrication d'articles textiles, sauf habillement",
  "13.93Z": "Fabrication de tapis et moquettes",
  "13.94Z": "Fabrication de ficelles, cordes et filets",
  "13.95Z": "Fabrication de non-tissés, sauf habillement",
  "13.96Z": "Fabrication d'autres textiles techniques et industriels",
  "13.99Z": "Fabrication d'autres textiles n.c.a.",
  "14.11Z": "Fabrication de vêtements en cuir",
  "14.12Z": "Fabrication de vêtements de travail",
  "14.13Z": "Fabrication de vêtements de dessus",
  "14.14Z": "Fabrication de vêtements de dessous",
  "14.19Z": "Fabrication d'autres vêtements et accessoires",
  "14.20Z": "Fabrication d'articles en fourrure",
  "14.31Z": "Fabrication d'articles chaussants à mailles",
  "14.39Z": "Fabrication d'autres articles à mailles",
  "15.11Z": "Apprêt et tannage des cuirs ; préparation et teinture des fourrures",
  "15.12Z": "Fabrication d'articles de voyage, de maroquinerie et de sellerie",
  "15.20Z": "Fabrication de chaussures",
  "16.10A": "Sciage et rabotage du bois, hors imprégnation",
  "16.10B": "Imprégnation du bois",
  "16.21Z": "Fabrication de placage et de panneaux de bois",
  "16.22Z": "Fabrication de parquets assemblés",
  "16.23Z": "Fabrication de charpentes et d'autres menuiseries",
  "16.24Z": "Fabrication d'emballages en bois",
  "16.29Z": "Fabrication d'objets divers en bois ; fabrication d'objets en liège, vannerie et sparterie",
  "17.11Z": "Fabrication de pâte à papier",
  "17.12Z": "Fabrication de papier et de carton",
  "17.21A": "Fabrication de carton ondulé",
  "17.21B": "Fabrication de cartonnages",
  "17.21C": "Fabrication d'emballages en papier",
  "17.22Z": "Fabrication d'articles en papier à usage sanitaire ou domestique",
  "17.23Z": "Fabrication d'articles de papeterie",
  "17.24Z": "Fabrication de papiers peints",
  "17.29Z": "Fabrication d'autres articles en papier ou en carton",
  "18.11Z": "Imprimerie de journaux",
  "18.12Z": "Autre imprimerie (labeur)",
  "18.13Z": "Activités de pré-presse",
  "18.14Z": "Reliure et activités connexes",
  "18.20Z": "Reproduction d'enregistrements",
  "19.10Z": "Cokéfaction",
  "19.20Z": "Raffinage du pétrole",
  "20.11Z": "Fabrication de gaz industriels",
  "20.12Z": "Fabrication de colorants et de pigments",
  "20.13A": "Enrichissement et retraitement de matières nucléaires",
  "20.13B": "Fabrication d'autres produits chimiques inorganiques de base n.c.a.",
  "20.14Z": "Fabrication d'autres produits chimiques organiques de base",
  "20.15Z": "Fabrication de produits azotés et d'engrais",
  "20.16Z": "Fabrication de matières plastiques de base",
  "20.17Z": "Fabrication de caoutchouc synthétique",
  "20.20Z": "Fabrication de pesticides et d'autres produits agrochimiques",
  "20.30Z": "Fabrication de peintures, vernis, encres et mastics",
  "20.41Z": "Fabrication de savons, détergents et produits d'entretien",
  "20.42Z": "Fabrication de parfums et de produits pour la toilette",
  "20.51Z": "Fabrication de produits explosifs",
  "20.52Z": "Fabrication de colles",
  "20.53Z": "Fabrication d'huiles essentielles",
  "20.59Z": "Fabrication d'autres produits chimiques n.c.a.",
  "20.60Z": "Fabrication de fibres artificielles ou synthétiques",
  "21.10Z": "Fabrication de produits pharmaceutiques de base",
  "21.20Z": "Fabrication de préparations pharmaceutiques",
  "22.11Z": "Fabrication et rechapage de pneumatiques",
  "22.19Z": "Fabrication d'autres articles en caoutchouc",
  "22.21Z": "Fabrication de plaques, feuilles, tubes et profilés en matières plastiques",
  "22.22Z": "Fabrication d'emballages en matières plastiques",
  "22.23Z": "Fabrication d'éléments en matières plastiques pour la construction",
  "22.29A": "Fabrication de pièces techniques à base de matières plastiques",
  "22.29B": "Fabrication de produits de consommation courante en matières plastiques",
  "23.11Z": "Fabrication de verre plat",
  "23.12Z": "Façonnage et transformation du verre plat",
  "23.13Z": "Fabrication de verre creux",
  "23.14Z": "Fabrication de fibres de verre",
  "23.19Z": "Fabrication et façonnage d'autres articles en verre, y compris verre technique",
  "23.20Z": "Fabrication de produits réfractaires",
  "23.31Z": "Fabrication de carreaux en céramique",
  "23.32Z": "Fabrication de briques, tuiles et produits de construction, en terre cuite",
  "23.41Z": "Fabrication d'articles céramiques à usage domestique ou ornemental",
  "23.42Z": "Fabrication d'appareils sanitaires en céramique",
  "23.43Z": "Fabrication d'isolateurs et pièces isolantes en céramique",
  "23.44Z": "Fabrication d'autres produits céramiques à usage technique",
  "23.49Z": "Fabrication d'autres produits céramiques",
  "23.51Z": "Fabrication de ciment",
  "23.52Z": "Fabrication de chaux et plâtre",
  "23.61Z": "Fabrication d'éléments en béton pour la construction",
  "23.62Z": "Fabrication d'éléments en plâtre pour la construction",
  "23.63Z": "Fabrication de béton prêt à l'emploi",
  "23.64Z": "Fabrication de mortiers et bétons secs",
  "23.65Z": "Fabrication d'ouvrages en fibre-ciment",
  "23.69Z": "Fabrication d'autres ouvrages en béton, en ciment ou en plâtre",
  "23.70Z": "Taille, façonnage et finissage de pierres",
  "23.91Z": "Fabrication de produits abrasifs",
  "23.99Z": "Fabrication d'autres produits minéraux non métalliques n.c.a.",
  "24.10Z": "Sidérurgie",
  "24.20Z": "Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier",
  "24.31Z": "Étirage à froid de barres",
  "24.32Z": "Laminage à froid de feuillards",
  "24.33Z": "Profilage à froid par formage ou pliage",
  "24.34Z": "Tréfilage à froid",
  "24.41Z": "Production de métaux précieux",
  "24.42Z": "Métallurgie de l'aluminium",
  "24.43Z": "Métallurgie du plomb, du zinc ou de l'étain",
  "24.44Z": "Métallurgie du cuivre",
  "24.45Z": "Métallurgie des autres métaux non ferreux",
  "24.46Z": "Élaboration et transformation de matières nucléaires",
  "24.51Z": "Fonderie de fonte",
  "24.52Z": "Fonderie d'acier",
  "24.53Z": "Fonderie de métaux légers",
  "24.54Z": "Fonderie d'autres métaux non ferreux",
  "25.11Z": "Fabrication de structures métalliques et de parties de structures",
  "25.12Z": "Fabrication de portes et fenêtres en métal",
  "25.21Z": "Fabrication de radiateurs et de chaudières pour le chauffage central",
  "25.29Z": "Fabrication d'autres réservoirs, citernes et conteneurs métalliques",
  "25.30Z": "Fabrication de générateurs de vapeur, à l'exception des chaudières pour le chauffage central",
  "25.40Z": "Fabrication d'armes et de munitions",
  "25.50A": "Forge, estampage, matriçage ; métallurgie des poudres",
  "25.50B": "Découpage, emboutissage",
  "25.61Z": "Traitement et revêtement des métaux",
  "25.62A": "Décolletage",
  "25.62B": "Mécanique industrielle",
  "25.71Z": "Fabrication de coutellerie",
  "25.72Z": "Fabrication de serrures et de ferrures",
  "25.73A": "Fabrication de moules et modèles",
  "25.73B": "Fabrication d'autres outillages",
  "25.91Z": "Fabrication de fûts et emballages métalliques similaires",
  "25.92Z": "Fabrication d'emballages métalliques légers",
  "25.93Z": "Fabrication d'articles en fils métalliques, de chaînes et de ressorts",
  "25.94Z": "Fabrication de vis et de boulons",
  "25.99A": "Fabrication d'articles métalliques ménagers",
  "25.99B": "Fabrication d'autres articles métalliques",
  "26.11Z": "Fabrication de composants électroniques",
  "26.12Z": "Fabrication de cartes électroniques assemblées",
  "26.20Z": "Fabrication d'ordinateurs et d'équipements périphériques",
  "26.30Z": "Fabrication d'équipements de communication",
  "26.40Z": "Fabrication de produits électroniques grand public",
  "26.51A": "Fabrication d'équipements d'aide à la navigation",
  "26.51B": "Fabrication d'instrumentation scientifique et technique",
  "26.52Z": "Horlogerie",
  "26.60Z": "Fabrication d'équipements d'irradiation médicale, d'équipements électromédicaux et électrothérapeutiques",
  "26.70Z": "Fabrication de matériels optique et photographique",
  "26.80Z": "Fabrication de supports magnétiques et optiques",
  "27.11Z": "Fabrication de moteurs, génératrices et transformateurs électriques",
  "27.12Z": "Fabrication de matériel de distribution et de commande électrique",
  "27.20Z": "Fabrication de piles et d'accumulateurs électriques",
  "27.31Z": "Fabrication de câbles de fibres optiques",
  "27.32Z": "Fabrication d'autres fils et câbles électroniques ou électriques",
  "27.33Z": "Fabrication de matériel d'installation électrique",
  "27.40Z": "Fabrication d'appareils d'éclairage électrique",
  "27.51Z": "Fabrication d'appareils électroménagers",
  "27.52Z": "Fabrication d'appareils ménagers non électriques",
  "27.90Z": "Fabrication d'autres matériels électriques",
  "28.11Z": "Fabrication de moteurs et turbines, à l'exception des moteurs d'avions et de véhicules",
  "28.12Z": "Fabrication d'équipements hydrauliques et pneumatiques",
  "28.13Z": "Fabrication d'autres pompes et compresseurs",
  "28.14Z": "Fabrication d'autres articles de robinetterie",
  "28.15Z": "Fabrication d'engrenages et d'organes mécaniques de transmission",
  "28.21Z": "Fabrication de fours et brûleurs",
  "28.22Z": "Fabrication de matériel de levage et de manutention",
  "28.23Z": "Fabrication de machines et d'équipements de bureau (à l'exception des ordinateurs et équipements périphériques)",
  "28.24Z": "Fabrication d'outillage portatif à moteur incorporé",
  "28.25Z": "Fabrication d'équipements aérauliques et frigorifiques industriels",
  "28.29A": "Fabrication d'équipements d'emballage, de conditionnement et de pesage",
  "28.29B": "Fabrication d'autres machines d'usage général",
  "28.30Z": "Fabrication de machines agricoles et forestières",
  "28.41Z": "Fabrication de machines-outils pour le travail des métaux",
  "28.49Z": "Fabrication d'autres machines-outils",
  "28.91Z": "Fabrication de machines pour la métallurgie",
  "28.92Z": "Fabrication de machines pour l'extraction ou la construction",
  "28.93Z": "Fabrication de machines pour l'industrie agro-alimentaire",
  "28.94Z": "Fabrication de machines pour les industries textiles",
  "28.95Z": "Fabrication de machines pour les industries du papier et du carton",
  "28.96Z": "Fabrication de machines pour le travail du caoutchouc ou des plastiques",
  "28.99A": "Fabrication de machines d'imprimerie",
  "28.99B": "Fabrication d'autres machines spécialisées",
  "29.10Z": "Construction de véhicules automobiles",
  "29.20Z": "Fabrication de carrosseries et remorques",
  "29.31Z": "Fabrication d'équipements électriques et électroniques automobiles",
  "29.32Z": "Fabrication d'autres équipements automobiles",
  "30.11Z": "Construction de navires et de structures flottantes",
  "30.12Z": "Construction de bateaux de plaisance",
  "30.20Z": "Construction de locomotives et d'autre matériel ferroviaire roulant",
  "30.30Z": "Construction aéronautique et spatiale",
  "30.40Z": "Construction de véhicules militaires de combat",
  "30.91Z": "Fabrication de motocycles",
  "30.92Z": "Fabrication de bicyclettes et de véhicules pour invalides",
  "30.99Z": "Fabrication d'autres équipements de transport n.c.a.",
  "31.01Z": "Fabrication de meubles de bureau et de magasin",
  "31.02Z": "Fabrication de meubles de cuisine",
  "31.03Z": "Fabrication de matelas",
  "31.09A": "Fabrication de sièges d'ameublement d'intérieur",
  "31.09B": "Fabrication d'autres meubles et industries connexes de l'ameublement",
  "32.11Z": "Frappe de monnaie",
  "32.12Z": "Fabrication d'articles de joaillerie et bijouterie",
  "32.13Z": "Fabrication d'articles de bijouterie fantaisie et articles similaires",
  "32.20Z": "Fabrication d'instruments de musique",
  "32.30Z": "Fabrication d'articles de sport",
  "32.40Z": "Fabrication de jeux et jouets",
  "32.50A": "Fabrication de matériel médico-chirurgical et dentaire",
  "32.50B": "Fabrication de lunettes",
  "32.91Z": "Fabrication d'articles de brosserie",
  "32.99Z": "Autres activités manufacturières n.c.a.",
  "33.11Z": "Réparation d'ouvrages en métaux",
  "33.12Z": "Réparation de machines et équipements mécaniques",
  "33.13Z": "Réparation de matériels électroniques et optiques",
  "33.14Z": "Réparation d'équipements électriques",
  "33.15Z": "Réparation et maintenance navale",
  "33.16Z": "Réparation et maintenance d'aéronefs et d'engins spatiaux",
  "33.17Z": "Réparation et maintenance d'autres équipements de transport",
  "33.19Z": "Réparation d'autres équipements",
  "33.20A": "Installation de structures métalliques, chaudronnées et de tuyauterie",
  "33.20B": "Installation de machines et équipements mécaniques",
  "33.20C": "Conception d'ensemble et assemblage sur site industriel d'équipements de contrôle des processus industriels",
  "33.20D": "Installation d'équipements électriques, de matériels électroniques et optiques ou d'autres matériels",
  "35.11Z": "Production d'électricité",
  "35.12Z": "Transport d'électricité",
  "35.13Z": "Distribution d'électricité",
  "35.14Z": "Commerce d'électricité",
  "35.21Z": "Production de combustibles gazeux",
  "35.22Z": "Distribution de combustibles gazeux par conduites",
  "35.23Z": "Commerce de combustibles gazeux par conduites",
  "35.30Z": "Production et distribution de vapeur et d'air conditionné",
  "36.00Z": "Captage, traitement et distribution d'eau",
  "37.00Z": "Collecte et traitement des eaux usées",
  "38.11Z": "Collecte des déchets non dangereux",
  "38.12Z": "Collecte des déchets dangereux",
  "38.21Z": "Traitement et élimination des déchets non dangereux",
  "38.22Z": "Traitement et élimination des déchets dangereux",
  "38.31Z": "Démantèlement d'épaves",
  "38.32Z": "Récupération de déchets triés",
  "39.00Z": "Dépollution et autres services de gestion des déchets",
  "41.10A": "Promotion immobilière de logements",
  "41.10B": "Promotion immobilière de bureaux",
  "41.10C": "Promotion immobilière d'autres bâtiments",
  "41.10D": "Supports juridiques de programmes",
  "41.20A": "Construction de maisons individuelles",
  "41.20B": "Construction d'autres bâtiments",
  "42.11Z": "Construction de routes et autoroutes",
  "42.12Z": "Construction de voies ferrées de surface et souterraines",
  "42.13A": "Construction d'ouvrages d'art",
  "42.13B": "Construction et entretien de tunnels",
  "42.21Z": "Construction de réseaux pour fluides",
  "42.22Z": "Construction de réseaux électriques et de télécommunications",
  "42.91Z": "Construction d'ouvrages maritimes et fluviaux",
  "42.99Z": "Construction d'autres ouvrages de génie civil n.c.a.",
  "43.11Z": "Travaux de démolition",
  "43.12A": "Travaux de terrassement courants et travaux préparatoires",
  "43.12B": "Travaux de terrassement spécialisés ou de grande masse",
  "43.13Z": "Forages et sondages",
  "43.21A": "Travaux d'installation électrique dans tous locaux",
  "43.21B": "Travaux d'installation électrique sur la voie publique",
  "43.22A": "Travaux d'installation d'eau et de gaz en tous locaux",
  "43.22B": "Travaux d'installation d'équipements thermiques et de climatisation",
  "43.29A": "Travaux d'isolation",
  "43.29B": "Autres travaux d'installation n.c.a.",
  "43.31Z": "Travaux de plâtrerie",
  "43.32A": "Travaux de menuiserie bois et PVC",
  "43.32B": "Travaux de menuiserie métallique et serrurerie",
  "43.32C": "Agencement de lieux de vente",
  "43.33Z": "Travaux de revêtement des sols et des murs",
  "43.34Z": "Travaux de peinture et vitrerie",
  "43.39Z": "Autres travaux de finition",
  "43.91A": "Travaux de charpente",
  "43.91B": "Travaux de couverture par éléments",
  "43.99A": "Travaux d'étanchéification",
  "43.99B": "Travaux de montage de structures métalliques",
  "43.99C": "Travaux de maçonnerie générale et gros œuvre de bâtiment",
  "43.99D": "Autres travaux spécialisés de construction",
  "43.99E": "Location avec opérateur de matériel de construction",
  "45.11Z": "Commerce de voitures et de véhicules automobiles légers",
  "45.19Z": "Commerce d'autres véhicules automobiles",
  "45.20A": "Entretien et réparation de véhicules automobiles légers",
  "45.20B": "Entretien et réparation d'autres véhicules automobiles",
  "45.31Z": "Commerce de gros d'équipements automobiles",
  "45.32Z": "Commerce de détail d'équipements automobiles",
  "45.40Z": "Commerce et réparation de motocycles",
  "46.11Z": "Intermédiaires du commerce en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis",
  "46.12A": "Centrales d'achat de carburant",
  "46.12B": "Autres intermédiaires du commerce en combustibles, métaux, minéraux et produits chimiques",
  "46.13Z": "Intermédiaires du commerce en bois et matériaux de construction",
  "46.14Z": "Intermédiaires du commerce en machines, équipements industriels, navires et avions",
  "46.15Z": "Intermédiaires du commerce en meubles, articles de ménage et quincaillerie",
  "46.16Z": "Intermédiaires du commerce en textiles, habillement, fourrures, chaussures et articles en cuir",
  "46.17A": "Centrales d'achat alimentaires",
  "46.17B": "Autres intermédiaires du commerce en denrées, boissons et tabac",
  "46.18Z": "Intermédiaires spécialisés dans le commerce d'autres produits spécifiques",
  "46.19A": "Centrales d'achat non alimentaires",
  "46.19B": "Autres intermédiaires du commerce en produits divers",
  "46.21Z": "Commerce de gros (commerce interentreprises) de céréales, de tabac non manufacturé, de semences et d'aliments pour le bétail",
  "46.22Z": "Commerce de gros (commerce interentreprises) de fleurs et plantes",
  "46.23Z": "Commerce de gros (commerce interentreprises) d'animaux vivants",
  "46.24Z": "Commerce de gros (commerce interentreprises) de cuirs et peaux",
  "46.31Z": "Commerce de gros (commerce interentreprises) de fruits et légumes",
  "46.32A": "Commerce de gros (commerce interentreprises) de viandes de boucherie",
  "46.32B": "Commerce de gros (commerce interentreprises) de produits à base de viande",
  "46.32C": "Commerce de gros (commerce interentreprises) de volailles et gibier",
  "46.33Z": "Commerce de gros (commerce interentreprises) de produits laitiers, œufs, huiles et matières grasses comestibles",
  "46.34Z": "Commerce de gros (commerce interentreprises) de boissons",
  "46.35Z": "Commerce de gros (commerce interentreprises) de produits à base de tabac",
  "46.36Z": "Commerce de gros (commerce interentreprises) de sucre, chocolat et confiserie",
  "46.37Z": "Commerce de gros (commerce interentreprises) de café, thé, cacao et épices",
  "46.38A": "Commerce de gros (commerce interentreprises) de poissons, crustacés et mollusques",
  "46.38B": "Commerce de gros (commerce interentreprises) alimentaire spécialisé divers",
  "46.39A": "Commerce de gros (commerce interentreprises) de produits surgelés",
  "46.39B": "Commerce de gros (commerce interentreprises) alimentaire non spécialisé",
  "46.41Z": "Commerce de gros (commerce interentreprises) de textiles",
  "46.42Z": "Commerce de gros (commerce interentreprises) d'habillement et de chaussures",
  "46.43Z": "Commerce de gros (commerce interentreprises) d'appareils électroménagers",
  "46.44Z": "Commerce de gros (commerce interentreprises) de vaisselle, verrerie et produits d'entretien",
  "46.45Z": "Commerce de gros (commerce interentreprises) de parfumerie et de produits de beauté",
  "46.46Z": "Commerce de gros (commerce interentreprises) de produits pharmaceutiques",
  "46.47Z": "Commerce de gros (commerce interentreprises) de meubles, de tapis et d'appareils d'éclairage",
  "46.48Z": "Commerce de gros (commerce interentreprises) d'articles d'horlogerie et de bijouterie",
  "46.49Z": "Commerce de gros (commerce interentreprises) d'autres biens domestiques",
  "46.51Z": "Commerce de gros (commerce interentreprises) d'ordinateurs, d'équipements informatiques périphériques et de logiciels",
  "46.52Z": "Commerce de gros (commerce interentreprises) de composants et d'équipements électroniques et de télécommunication",
  "46.61Z": "Commerce de gros (commerce interentreprises) de matériel agricole",
  "46.62Z": "Commerce de gros (commerce interentreprises) de machines-outils",
  "46.63Z": "Commerce de gros (commerce interentreprises) de machines pour l'extraction, la construction et le génie civil",
  "46.64Z": "Commerce de gros (commerce interentreprises) de machines pour l'industrie textile et l'habillement",
  "46.65Z": "Commerce de gros (commerce interentreprises) de mobilier de bureau",
  "46.66Z": "Commerce de gros (commerce interentreprises) d'autres machines et équipements de bureau",
  "46.69A": "Commerce de gros (commerce interentreprises) de matériel électrique",
  "46.69B": "Commerce de gros (commerce interentreprises) de fournitures et équipements industriels divers",
  "46.69C": "Commerce de gros (commerce interentreprises) de fournitures et équipements divers pour le commerce et les services",
  "46.71Z": "Commerce de gros (commerce interentreprises) de combustibles et de produits annexes",
  "46.72Z": "Commerce de gros (commerce interentreprises) de minerais et métaux",
  "46.73A": "Commerce de gros (commerce interentreprises) de bois et de matériaux de construction",
  "46.73B": "Commerce de gros (commerce interentreprises) d'appareils sanitaires et de produits de décoration",
  "46.74A": "Commerce de gros (commerce interentreprises) de quincaillerie",
  "46.74B": "Commerce de gros (commerce interentreprises) de fournitures pour la plomberie et le chauffage",
  "46.75Z": "Commerce de gros (commerce interentreprises) de produits chimiques",
  "46.76Z": "Commerce de gros (commerce interentreprises) d'autres produits intermédiaires",
  "46.77Z": "Commerce de gros (commerce interentreprises) de déchets et débris",
  "46.90Z": "Commerce de gros (commerce interentreprises) non spécialisé",
  "47.11A": "Commerce de détail de produits surgelés",
  "47.11B": "Commerce d'alimentation générale",
  "47.11C": "Supérettes",
  "47.11D": "Supermarchés",
  "47.11E": "Magasins multi-commerces",
  "47.11F": "Hypermarchés",
  "47.19A": "Grands magasins",
  "47.19B": "Autres commerces de détail en magasin non spécialisé",
  "47.21Z": "Commerce de détail de fruits et légumes en magasin spécialisé",
  "47.22Z": "Commerce de détail de viandes et de produits à base de viande en magasin spécialisé",
  "47.23Z": "Commerce de détail de poissons, crustacés et mollusques en magasin spécialisé",
  "47.24Z": "Commerce de détail de pain, pâtisserie et confiserie en magasin spécialisé",
  "47.25Z": "Commerce de détail de boissons en magasin spécialisé",
  "47.26Z": "Commerce de détail de produits à base de tabac en magasin spécialisé",
  "47.29Z": "Autres commerces de détail alimentaires en magasin spécialisé",
  "47.30Z": "Commerce de détail de carburants en magasin spécialisé",
  "47.41Z": "Commerce de détail d'ordinateurs, d'unités périphériques et de logiciels en magasin spécialisé",
  "47.42Z": "Commerce de détail de matériels de télécommunication en magasin spécialisé",
  "47.43Z": "Commerce de détail de matériels audio et vidéo en magasin spécialisé",
  "47.51Z": "Commerce de détail de textiles en magasin spécialisé",
  "47.52A": "Commerce de détail de quincaillerie, peintures et verres en petites surfaces (moins de 400 m²)",
  "47.52B": "Commerce de détail de quincaillerie, peintures et verres en grandes surfaces (400 m² et plus)",
  "47.53Z": "Commerce de détail de tapis, moquettes et revêtements de murs et de sols en magasin spécialisé",
  "47.54Z": "Commerce de détail d'appareils électroménagers en magasin spécialisé",
  "47.59A": "Commerce de détail de meubles",
  "47.59B": "Commerce de détail d'autres équipements du foyer",
  "47.61Z": "Commerce de détail de livres en magasin spécialisé",
  "47.62Z": "Commerce de détail de journaux et papeterie en magasin spécialisé",
  "47.63Z": "Commerce de détail d'enregistrements musicaux et vidéo en magasin spécialisé",
  "47.64Z": "Commerce de détail d'articles de sport en magasin spécialisé",
  "47.65Z": "Commerce de détail de jeux et jouets en magasin spécialisé",
  "47.71Z": "Commerce de détail d'habillement en magasin spécialisé",
  "47.72A": "Commerce de détail de la chaussure",
  "47.72B": "Commerce de détail de maroquinerie et d'articles de voyage",
  "47.73Z": "Commerce de détail de produits pharmaceutiques en magasin spécialisé",
  "47.74Z": "Commerce de détail d'articles médicaux et orthopédiques en magasin spécialisé",
  "47.75Z": "Commerce de détail de parfumerie et de produits de beauté en magasin spécialisé",
  "47.76Z": "Commerce de détail de fleurs, plantes, graines, engrais, animaux de compagnie et aliments pour ces animaux en magasin spécialisé",
  "47.77Z": "Commerce de détail d'articles d'horlogerie et de bijouterie en magasin spécialisé",
  "47.78A": "Commerces de détail d'optique",
  "47.78B": "Commerces de détail de charbons et combustibles",
  "47.78C": "Autres commerces de détail spécialisés divers",
  "47.79Z": "Commerce de détail de biens d'occasion en magasin",
  "47.81Z": "Commerce de détail alimentaire sur éventaires et marchés",
  "47.82Z": "Commerce de détail de textiles, d'habillement et de chaussures sur éventaires et marchés",
  "47.89Z": "Autres commerces de détail sur éventaires et marchés",
  "47.91A": "Vente à distance sur catalogue général",
  "47.91B": "Vente à distance sur catalogue spécialisé",
  "47.99A": "Vente à domicile",
  "47.99B": "Vente par automates et autres commerces de détail hors magasin, éventaires ou marchés n.c.a.",
  "49.10Z": "Transport ferroviaire interurbain de voyageurs",
  "49.20Z": "Transports ferroviaires de fret",
  "49.31Z": "Transports urbains et suburbains de voyageurs",
  "49.32Z": "Transports de voyageurs par taxis",
  "49.39A": "Transports routiers réguliers de voyageurs",
  "49.39B": "Autres transports routiers de voyageurs",
  "49.39C": "Téléphériques et remontées mécaniques",
  "49.41A": "Transports routiers de fret interurbains",
  "49.41B": "Transports routiers de fret de proximité",
  "49.41C": "Location de camions avec chauffeur",
  "49.42Z": "Services de déménagement",
  "49.50Z": "Transports par conduites",
  "50.10Z": "Transports maritimes et côtiers de passagers",
  "50.20Z": "Transports maritimes et côtiers de fret",
  "50.30Z": "Transports fluviaux de passagers",
  "50.40Z": "Transports fluviaux de fret",
  "51.10Z": "Transports aériens de passagers",
  "51.21Z": "Transports aériens de fret",
  "51.22Z": "Transports spatiaux",
  "52.10A": "Entreposage et stockage frigorifique",
  "52.10B": "Entreposage et stockage non frigorifique",
  "52.21Z": "Services auxiliaires des transports terrestres",
  "52.22Z": "Services auxiliaires des transports par eau",
  "52.23Z": "Services auxiliaires des transports aériens",
  "52.24A": "Manutention portuaire",
  "52.24B": "Manutention non portuaire",
  "52.29A": "Messagerie, fret express",
  "52.29B": "Affrètement et organisation des transports",
  "53.10Z": "Activités de poste dans le cadre d'une obligation de service universel",
  "53.20Z": "Autres activités de poste et de courrier",
  "55.10Z": "Hôtels et hébergement similaire",
  "55.20Z": "Hébergement touristique et autre hébergement de courte durée",
  "55.30Z": "Terrains de camping et parcs pour caravanes ou véhicules de loisirs",
  "55.90Z": "Autres hébergements",
  "56.10A": "Restauration traditionnelle",
  "56.10B": "Cafétérias et autres libres-services",
  "56.10C": "Restauration de type rapide",
  "56.21Z": "Services des traiteurs",
  "56.29A": "Restauration collective sous contrat",
  "56.29B": "Autres services de restauration n.c.a.",
  "56.30Z": "Débits de boissons",
  "58.11Z": "Édition de livres",
  "58.12Z": "Édition de répertoires et de fichiers d'adresses",
  "58.13Z": "Édition de journaux",
  "58.14Z": "Édition de revues et périodiques",
  "58.19Z": "Autres activités d'édition",
  "58.21Z": "Édition de jeux électroniques",
  "58.29A": "Édition de logiciels système et de réseau",
  "58.29B": "Édition de logiciels outils de développement et de langages",
  "58.29C": "Édition de logiciels applicatifs",
  "59.11A": "Production de films et de programmes pour la télévision",
  "59.11B": "Production de films institutionnels et publicitaires",
  "59.11C": "Production de films pour le cinéma",
  "59.12Z": "Post-production de films cinématographiques, de vidéo et de programmes de télévision",
  "59.13A": "Distribution de films cinématographiques",
  "59.13B": "Édition et distribution vidéo",
  "59.14Z": "Projection de films cinématographiques",
  "59.20Z": "Enregistrement sonore et édition musicale",
  "60.10Z": "Édition et diffusion de programmes radio",
  "60.20A": "Édition de chaînes généralistes",
  "60.20B": "Édition de chaînes thématiques",
  "61.10Z": "Télécommunications filaires",
  "61.20Z": "Télécommunications sans fil",
  "61.30Z": "Télécommunications par satellite",
  "61.90Z": "Autres activités de télécommunication",
  "62.01Z": "Programmation informatique",
  "62.02A": "Conseil en systèmes et logiciels informatiques",
  "62.02B": "Tierce maintenance de systèmes et d'applications informatiques",
  "62.03Z": "Gestion d'installations informatiques",
  "62.09Z": "Autres activités informatiques",
  "63.11Z": "Traitement de données, hébergement et activités connexes",
  "63.12Z": "Portails Internet",
  "63.91Z": "Activités des agences de presse",
  "63.99Z": "Autres services d'information n.c.a.",
  "64.11Z": "Activités de banque centrale",
  "64.19Z": "Autres intermédiations monétaires",
  "64.20Z": "Activités des sociétés holding",
  "64.30Z": "Fonds de placement et entités financières similaires",
  "64.91Z": "Crédit-bail",
  "64.92Z": "Autre distribution de crédit",
  "64.99Z": "Autres activités des services financiers, hors assurance et caisses de retraite, n.c.a.",
  "65.11Z": "Assurance vie",
  "65.12Z": "Autres assurances",
  "65.20Z": "Réassurance",
  "65.30Z": "Caisses de retraite",
  "66.11Z": "Administration de marchés financiers",
  "66.12Z": "Courtage de valeurs mobilières et de marchandises",
  "66.19A": "Supports juridiques de gestion de patrimoine mobilier",
  "66.19B": "Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite, n.c.a.",
  "66.21Z": "Évaluation des risques et dommages",
  "66.22Z": "Activités des agents et courtiers d'assurances",
  "66.29Z": "Autres activités auxiliaires d'assurance et de caisses de retraite",
  "66.30Z": "Gestion de fonds",
  "68.10Z": "Activités des marchands de biens immobiliers",
  "68.20A": "Location de logements",
  "68.20B": "Location de terrains et d'autres biens immobiliers",
  "68.31Z": "Agences immobilières",
  "68.32A": "Administration d'immeubles et autres biens immobiliers",
  "68.32B": "Supports juridiques de gestion de patrimoine immobilier",
  "69.10Z": "Activités juridiques",
  "69.20Z": "Activités comptables",
  "70.10Z": "Activités des sièges sociaux",
  "70.21Z": "Conseil en relations publiques et communication",
  "70.22Z": "Conseil pour les affaires et autres conseils de gestion",
  "71.11Z": "Activités d'architecture",
  "71.12A": "Activité des géomètres",
  "71.12B": "Ingénierie, études techniques",
  "71.20A": "Contrôle technique automobile",
  "71.20B": "Analyses, essais et inspections techniques",
  "72.11Z": "Recherche-développement en biotechnologie",
  "72.19Z": "Recherche-développement en autres sciences physiques et naturelles",
  "72.20Z": "Recherche-développement en sciences humaines et sociales",
  "73.11Z": "Activités des agences de publicité",
  "73.12Z": "Régie publicitaire de médias",
  "73.20Z": "Études de marché et sondages",
  "74.10Z": "Activités spécialisées de design",
  "74.20Z": "Activités photographiques",
  "74.30Z": "Traduction et interprétation",
  "74.90A": "Activité des économistes de la construction",
  "74.90B": "Activités spécialisées, scientifiques et techniques diverses",
  "75.00Z": "Activités vétérinaires",
  "77.11A": "Location de courte durée de voitures et de véhicules automobiles légers",
  "77.11B": "Location de longue durée de voitures et de véhicules automobiles légers",
  "77.12Z": "Location et location-bail de camions",
  "77.21Z": "Location et location-bail d'articles de loisirs et de sport",
  "77.22Z": "Location de vidéocassettes et disques vidéo",
  "77.29Z": "Location et location-bail d'autres biens personnels et domestiques",
  "77.31Z": "Location et location-bail de machines et équipements agricoles",
  "77.32Z": "Location et location-bail de machines et équipements pour la construction",
  "77.33Z": "Location et location-bail de machines de bureau et de matériel informatique",
  "77.34Z": "Location et location-bail de matériels de transport par eau",
  "77.35Z": "Location et location-bail de matériels de transport aérien",
  "77.39Z": "Location et location-bail d'autres machines, équipements et biens matériels n.c.a.",
  "77.40Z": "Location-bail de propriété intellectuelle et de produits similaires, à l'exception des œuvres soumises à copyright",
  "78.10Z": "Activités des agences de placement de main-d'œuvre",
  "78.20Z": "Activités des agences de travail temporaire",
  "78.30Z": "Autre mise à disposition de ressources humaines",
  "79.11Z": "Activités des agences de voyage",
  "79.12Z": "Activités des voyagistes",
  "79.90Z": "Autres services de réservation et activités connexes",
  "80.10Z": "Activités de sécurité privée",
  "80.20Z": "Activités liées aux systèmes de sécurité",
  "80.30Z": "Activités d'enquête",
  "81.10Z": "Activités combinées de soutien lié aux bâtiments",
  "81.21Z": "Nettoyage courant des bâtiments",
  "81.22Z": "Autres activités de nettoyage des bâtiments et nettoyage industriel",
  "81.29A": "Désinfection, désinsectisation, dératisation",
  "81.29B": "Autres activités de nettoyage n.c.a.",
  "81.30Z": "Services d'aménagement paysager",
  "82.11Z": "Services administratifs combinés de bureau",
  "82.19Z": "Photocopie, préparation de documents et autres activités spécialisées de soutien de bureau",
  "82.20Z": "Activités de centres d'appels",
  "82.30Z": "Organisation de foires, salons professionnels et congrès",
  "82.91Z": "Activités des agences de recouvrement de factures et des sociétés d'information financière sur la clientèle",
  "82.92Z": "Activités de conditionnement",
  "82.99Z": "Autres activités de soutien aux entreprises n.c.a.",
  "84.11Z": "Administration publique générale",
  "84.12Z": "Administration publique (tutelle) de la santé, de la formation, de la culture et des services sociaux, autre que sécurité sociale",
  "84.13Z": "Administration publique (tutelle) des activités économiques",
  "84.21Z": "Affaires étrangères",
  "84.22Z": "Défense",
  "84.23Z": "Justice",
  "84.24Z": "Activités d'ordre public et de sécurité",
  "84.25Z": "Services du feu et de secours",
  "84.30A": "Activités générales de sécurité sociale",
  "84.30B": "Gestion des retraites complémentaires",
  "84.30C": "Distribution sociale de revenus",
  "85.10Z": "Enseignement pré-primaire",
  "85.20Z": "Enseignement primaire",
  "85.31Z": "Enseignement secondaire général",
  "85.32Z": "Enseignement secondaire technique ou professionnel",
  "85.41Z": "Enseignement post-secondaire non supérieur",
  "85.42Z": "Enseignement supérieur",
  "85.51Z": "Enseignement de disciplines sportives et d'activités de loisirs",
  "85.52Z": "Enseignement culturel",
  "85.53Z": "Enseignement de la conduite",
  "85.59A": "Formation continue d'adultes",
  "85.59B": "Autres enseignements",
  "85.60Z": "Activités de soutien à l'enseignement",
  "86.10Z": "Activités hospitalières",
  "86.21Z": "Activité des médecins généralistes",
  "86.22A": "Activités de radiodiagnostic et de radiothérapie",
  "86.22B": "Activités chirurgicales",
  "86.22C": "Autres activités des médecins spécialistes",
  "86.23Z": "Pratique dentaire",
  "86.90A": "Ambulances",
  "86.90B": "Laboratoires d'analyses médicales",
  "86.90C": "Centres de collecte et banques d'organes",
  "86.90D": "Activités des infirmiers et des sages-femmes",
  "86.90E": "Activités des professionnels de la rééducation, de l'appareillage et des pédicures-podologues",
  "86.90F": "Activités de santé humaine non classées ailleurs",
  "87.10A": "Hébergement médicalisé pour personnes âgées",
  "87.10B": "Hébergement médicalisé pour enfants handicapés",
  "87.10C": "Hébergement médicalisé pour adultes handicapés et autre hébergement médicalisé",
  "87.20A": "Hébergement social pour handicapés mentaux et malades mentaux",
  "87.20B": "Hébergement social pour toxicomanes",
  "87.30A": "Hébergement social pour personnes âgées",
  "87.30B": "Hébergement social pour handicapés physiques",
  "87.90A": "Hébergement social pour enfants en difficultés",
  "87.90B": "Hébergement social pour adultes et familles en difficultés et autre hébergement social",
  "88.10A": "Aide à domicile",
  "88.10B": "Accueil ou accompagnement sans hébergement d'adultes handicapés ou de personnes âgées",
  "88.10C": "Aide par le travail",
  "88.91A": "Accueil de jeunes enfants",
  "88.91B": "Accueil ou accompagnement sans hébergement d'enfants handicapés",
  "88.99A": "Autre accueil ou accompagnement sans hébergement d'enfants et d'adolescents",
  "88.99B": "Action sociale sans hébergement n.c.a.",
  "90.01Z": "Arts du spectacle vivant",
  "90.02Z": "Activités de soutien au spectacle vivant",
  "90.03A": "Création artistique relevant des arts plastiques",
  "90.03B": "Autre création artistique",
  "90.04Z": "Gestion de salles de spectacles",
  "91.01Z": "Gestion des bibliothèques et des archives",
  "91.02Z": "Gestion des musées",
  "91.03Z": "Gestion des sites et monuments historiques et des attractions touristiques similaires",
  "91.04Z": "Gestion des jardins botaniques et zoologiques et des réserves naturelles",
  "92.00Z": "Organisation de jeux de hasard et d'argent",
  "93.11Z": "Gestion d'installations sportives",
  "93.12Z": "Activités de clubs de sports",
  "93.13Z": "Activités des centres de culture physique",
  "93.19Z": "Autres activités liées au sport",
  "93.21Z": "Activités des parcs d'attractions et parcs à thèmes",
  "93.29Z": "Autres activités récréatives et de loisirs",
  "94.11Z": "Activités des organisations patronales et consulaires",
  "94.12Z": "Activités des organisations professionnelles",
  "94.20Z": "Activités des syndicats de salariés",
  "94.91Z": "Activités des organisations religieuses",
  "94.92Z": "Activités des organisations politiques",
  "94.99Z": "Autres organisations fonctionnant par adhésion volontaire",
  "95.11Z": "Réparation d'ordinateurs et d'équipements périphériques",
  "95.12Z": "Réparation d'équipements de communication",
  "95.21Z": "Réparation de produits électroniques grand public",
  "95.22Z": "Réparation d'appareils électroménagers et d'équipements pour la maison et le jardin",
  "95.23Z": "Réparation de chaussures et d'articles en cuir",
  "95.24Z": "Réparation de meubles et d'équipements du foyer",
  "95.25Z": "Réparation d'articles d'horlogerie et de bijouterie",
  "95.29Z": "Réparation d'autres biens personnels et domestiques",
  "96.01A": "Blanchisserie-teinturerie de gros",
  "96.01B": "Blanchisserie-teinturerie de détail",
  "96.02A": "Coiffure",
  "96.02B": "Soins de beauté",
  "96.03Z": "Services funéraires",
  "96.04Z": "Entretien corporel",
  "96.09Z": "Autres services personnels n.c.a.",
  "97.00Z": "Activités des ménages en tant qu'employeurs de personnel domestique",
  "98.10Z": "Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre",
  "98.20Z": "Activités indifférenciées des ménages en tant que producteurs de services pour usage propre",
  "99.00Z": "Activités des organisations et organismes extraterritoriaux",
};

/** NAF 2025 — 747 sous-classes, libellés tels que l’INSEE les publie. */
export const NAF_2025_LABELS: Readonly<Record<string, string>> = {
  "01.11Y": "Culture de céréales, à l’exception du riz, de légumineuses et de graines oléagineuses",
  "01.12Y": "Culture du riz",
  "01.13Y": "Culture de légumes, de melons, de racines et de tubercules",
  "01.14Y": "Culture de la canne à sucre",
  "01.15Y": "Culture du tabac",
  "01.16Y": "Culture de plantes à fibres",
  "01.19Y": "Autres cultures non permanentes",
  "01.21Y": "Culture de la vigne",
  "01.22Y": "Culture de fruits tropicaux et subtropicaux",
  "01.23Y": "Culture d’agrumes",
  "01.24Y": "Culture de fruits à pépins et à noyau",
  "01.25Y": "Culture d’autres fruits d’arbres ou d’arbustes et de fruits à coque",
  "01.26Y": "Culture de fruits oléagineux",
  "01.27Y": "Culture de plantes à boissons",
  "01.28Y": "Culture de plantes à épices, aromatiques, médicinales et pharmaceutiques",
  "01.29Y": "Autres cultures permanentes",
  "01.30Y": "Reproduction de plantes",
  "01.41Y": "Élevage de vaches laitières",
  "01.42Y": "Élevage d’autres bovins et de buffles",
  "01.43Y": "Élevage de chevaux et d’autres équidés",
  "01.44Y": "Élevage de chameaux et d’autres camélidés",
  "01.45Y": "Élevage d’ovins et de caprins",
  "01.46Y": "Élevage de porcins",
  "01.47Y": "Élevage de volailles",
  "01.48G": "Apiculture",
  "01.48H": "Élevage d'autres animaux destinés à la consommation",
  "01.48J": "Élevage d'animaux de compagnie et d'autres animaux n.c.a.",
  "01.50Y": "Culture et élevage associés",
  "01.61Y": "Activités de soutien aux cultures",
  "01.62Y": "Activités de soutien à la production animale",
  "01.63Y": "Traitement primaire des récoltes et traitement des semences",
  "01.70Y": "Chasse, piégeage et activités de service connexes",
  "02.10Y": "Sylviculture et autres activités forestières",
  "02.20Y": "Exploitation forestière",
  "02.30Y": "Récolte de produits forestiers non ligneux poussant à l’état sauvage",
  "02.40Y": "Activités de soutien à l’exploitation forestière",
  "03.11Y": "Pêche en mer",
  "03.12Y": "Pêche en eau douce",
  "03.21Y": "Aquaculture en mer",
  "03.22Y": "Aquaculture en eau douce",
  "03.30Y": "Activités de soutien à la pêche et l’aquaculture",
  "05.10Y": "Extraction de houille",
  "05.20Y": "Extraction de lignite",
  "06.10Y": "Extraction de pétrole brut",
  "06.20Y": "Extraction de gaz naturel",
  "07.10Y": "Extraction de minerais de fer",
  "07.21Y": "Extraction de minerais d’uranium et de thorium",
  "07.29Y": "Extraction d’autres minerais de métaux non ferreux",
  "08.11Y": "Extraction de pierres ornementales, de calcaire industriel, de gypse, d’ardoise et d’autres pierres",
  "08.12Y": "Exploitation de gravières et sablières, extraction d’argiles et de kaolin",
  "08.91Y": "Extraction de minéraux chimiques et d’engrais minéraux",
  "08.92Y": "Extraction de tourbe",
  "08.93Y": "Production de sel",
  "08.99Y": "Autres activités extractives n.c.a.",
  "09.10Y": "Activités de soutien à l’extraction d’hydrocarbures",
  "09.90Y": "Activités de soutien aux autres industries extractives",
  "10.11Y": "Transformation et conservation de la viande, à l’exception de la viande de volaille",
  "10.12Y": "Transformation et conservation de la viande de volaille",
  "10.13G": "Préparation industrielle de produits à base de viande",
  "10.13H": "Préparation de produits à base de viande associée à leur vente au détail",
  "10.20Y": "Transformation et conservation de poisson, de crustacés et de mollusques",
  "10.31Y": "Transformation et conservation de pommes de terre",
  "10.32Y": "Préparation de jus de fruits et légumes",
  "10.39G": "Autre transformation et conservation de légumes",
  "10.39H": "Autre transformation et conservation de fruits",
  "10.41Y": "Fabrication d’huiles et graisses",
  "10.42Y": "Fabrication de margarine et graisses comestibles similaires",
  "10.51G": "Fabrication de lait liquide, crèmes de lait et laits fermentés",
  "10.51H": "Fabrication de fromage",
  "10.51J": "Fabrication de beurre et d'autres produits laitiers",
  "10.52Y": "Fabrication de crèmes glacées et autres glaces alimentaires",
  "10.61G": "Meunerie",
  "10.61H": "Autres activités du travail des grains",
  "10.62Y": "Fabrication de produits amylacés",
  "10.71G": "Fabrication industrielle de pain et de pâtisserie fraîche",
  "10.71H": "Fabrication de pain et d'autres produits de boulangerie-pâtisserie associée à leur vente au détail",
  "10.71J": "Fabrication de pâtisserie fraîche associée à sa vente au détail",
  "10.72Y": "Fabrication de biscuits, biscottes et pâtisseries de conservation",
  "10.73Y": "Fabrication de pâtes alimentaires",
  "10.81Y": "Fabrication de sucre",
  "10.82Y": "Fabrication de cacao, de chocolat et de produits de confiserie",
  "10.83Y": "Transformation du thé et du café",
  "10.84Y": "Fabrication de condiments et assaisonnements",
  "10.85Y": "Fabrication de plats préparés",
  "10.86Y": "Fabrication d’aliments homogénéisés et diététiques",
  "10.89Y": "Fabrication d’autres produits alimentaires n.c.a.",
  "10.91Y": "Fabrication d’aliments pour animaux de ferme",
  "10.92Y": "Fabrication d’aliments pour animaux de compagnie",
  "11.01Y": "Production de boissons alcoolisées distillées",
  "11.02G": "Fabrication de vins effervescents",
  "11.02H": "Fabrication de vins non effervescents",
  "11.03Y": "Fabrication de cidre et autres boissons fermentées à base de fruits",
  "11.04Y": "Production d’autres boissons fermentées non distillées",
  "11.05Y": "Fabrication de bière",
  "11.06Y": "Fabrication de malt",
  "11.07G": "Industrie des eaux de table",
  "11.07H": "Production d'autres boissons non alcoolisées",
  "12.00Y": "Fabrication de produits à base de tabac",
  "13.10Y": "Préparation de fibres textiles et filature",
  "13.20Y": "Tissage",
  "13.30Y": "Ennoblissement textile",
  "13.91Y": "Fabrication d’étoffes à mailles",
  "13.92Y": "Fabrication de textiles ménagers et d’articles d’ameublement confectionnés",
  "13.93Y": "Fabrication de tapis et moquettes",
  "13.94Y": "Fabrication de ficelles, cordes et filets",
  "13.95Y": "Fabrication de textiles non-tissés et articles non-tissés",
  "13.96Y": "Fabrication d’autres textiles techniques et industriels",
  "13.99Y": "Fabrication d’autres textiles n.c.a.",
  "14.10Y": "Fabrication d’articles à mailles",
  "14.21Y": "Fabrication de vêtements de dessus",
  "14.22Y": "Fabrication de vêtements de dessous",
  "14.23Y": "Fabrication de vêtements de travail",
  "14.24Y": "Fabrication de vêtements en cuir et en fourrure",
  "14.29Y": "Fabrication d’autres articles d’habillement et accessoires n.c.a.",
  "15.11Y": "Tannage, apprêt et teinture des cuirs et des fourrures",
  "15.12Y": "Fabrication de bagages, de maroquinerie, sellerie et bourrellerie, en toutes matières",
  "15.20Y": "Fabrication de chaussures",
  "16.11Y": "Sciage et rabotage du bois",
  "16.12Y": "Façonnage et finition du bois",
  "16.21Y": "Fabrication de placage et de panneaux de bois",
  "16.22Y": "Fabrication de parquets assemblés",
  "16.23Y": "Fabrication de charpentes et d’autres menuiseries",
  "16.24Y": "Fabrication d’emballages en bois",
  "16.25Y": "Fabrication de portes et fenêtres en bois",
  "16.26Y": "Fabrication de combustibles solides à partir de biomasse végétale",
  "16.27Y": "Finition de produits en bois",
  "16.28Y": "Fabrication d’objets divers en bois, d’objets en liège, vannerie et sparterie",
  "17.11Y": "Fabrication de pâte à papier",
  "17.12Y": "Fabrication de papier et de carton",
  "17.21Y": "Fabrication de papier et carton ondulés et d’emballages en papier ou en carton",
  "17.22Y": "Fabrication d’articles en papier à usage sanitaire ou domestique",
  "17.23Y": "Fabrication d’articles de papeterie",
  "17.24Y": "Fabrication de papiers peints",
  "17.25Y": "Fabrication d’autres articles en papier ou en carton",
  "18.11Y": "Imprimerie de journaux",
  "18.12Y": "Autres activités d’imprimerie",
  "18.13Y": "Activités de pré-presse",
  "18.14Y": "Reliure et activités connexes",
  "18.20Y": "Reproduction d’enregistrements",
  "19.10Y": "Cokéfaction",
  "19.20Y": "Raffinage du pétrole et fabrication de produits à base de combustibles fossiles",
  "20.11Y": "Fabrication de gaz industriels",
  "20.12Y": "Fabrication de colorants et de pigments",
  "20.13Y": "Fabrication d’autres produits chimiques inorganiques de base",
  "20.14Y": "Fabrication d’autres produits chimiques organiques de base",
  "20.15Y": "Fabrication de produits azotés et d’engrais",
  "20.16Y": "Fabrication de matières plastiques de base",
  "20.17Y": "Fabrication de caoutchouc synthétique",
  "20.20Y": "Fabrication de pesticides, de désinfectants et d’autres produits agrochimiques",
  "20.30Y": "Fabrication de peintures, vernis, encres et mastics",
  "20.41Y": "Fabrication de savons, détergents et produits d’entretien",
  "20.42Y": "Fabrication de parfums et de produits pour la toilette",
  "20.51Y": "Fabrication de biocarburants liquides",
  "20.59Y": "Fabrication d’autres produits chimiques n.c.a.",
  "20.60Y": "Fabrication de fibres artificielles ou synthétiques",
  "21.10Y": "Fabrication de produits pharmaceutiques de base",
  "21.20Y": "Fabrication de préparations pharmaceutiques",
  "22.11Y": "Fabrication et rechapage de pneus en caoutchouc et fabrication de chambres à air",
  "22.12Y": "Fabrication d’autres articles en caoutchouc",
  "22.21Y": "Fabrication de plaques, feuilles, tubes et profilés en matières plastiques",
  "22.22Y": "Fabrication d’emballages en matières plastiques",
  "22.23Y": "Fabrication de portes et fenêtres en matières plastiques",
  "22.24Y": "Fabrication d’éléments en matières plastiques pour la construction",
  "22.25Y": "Façonnage et finition de produits en matières plastiques",
  "22.26Y": "Fabrication d’autres articles en matières plastiques",
  "23.11Y": "Fabrication de verre plat",
  "23.12Y": "Façonnage et transformation du verre plat",
  "23.13Y": "Fabrication de verre creux",
  "23.14Y": "Fabrication de fibres de verre",
  "23.15Y": "Fabrication et façonnage d’autres articles en verre, y compris verre technique",
  "23.20Y": "Fabrication de produits réfractaires",
  "23.31Y": "Fabrication de carreaux en céramique",
  "23.32Y": "Fabrication de briques, tuiles et produits de construction, en terre cuite",
  "23.41Y": "Fabrication d’articles céramiques à usage domestique ou ornemental",
  "23.42Y": "Fabrication d’appareils sanitaires en céramique",
  "23.43Y": "Fabrication d’isolateurs et pièces isolantes en céramique",
  "23.44Y": "Fabrication d’autres produits céramiques à usage technique",
  "23.45Y": "Fabrication d’autres produits céramiques",
  "23.51Y": "Fabrication de ciment",
  "23.52Y": "Fabrication de chaux et plâtre",
  "23.61Y": "Fabrication d’éléments en béton pour la construction",
  "23.62Y": "Fabrication d’éléments en plâtre pour la construction",
  "23.63Y": "Fabrication de béton prêt à l’emploi",
  "23.64Y": "Fabrication de mortiers et de bétons secs",
  "23.65Y": "Fabrication d’ouvrages en fibre-ciment",
  "23.66Y": "Fabrication d’autres ouvrages en béton, en ciment ou en plâtre",
  "23.70Y": "Taille, façonnage et finissage de pierres",
  "23.91Y": "Fabrication de produits abrasifs",
  "23.99Y": "Fabrication d’autres produits minéraux non métalliques n.c.a.",
  "24.10Y": "Sidérurgie",
  "24.20Y": "Fabrication de tubes, tuyaux, profilés creux et accessoires correspondants en acier",
  "24.31Y": "Étirage à froid de barres",
  "24.32Y": "Laminage à froid de feuillards",
  "24.33Y": "Profilage à froid par formage ou pliage",
  "24.34Y": "Tréfilage à froid",
  "24.41Y": "Production de métaux précieux",
  "24.42Y": "Métallurgie de l’aluminium",
  "24.43Y": "Métallurgie du plomb, du zinc ou de l’étain",
  "24.44Y": "Métallurgie du cuivre",
  "24.45Y": "Métallurgie des autres métaux non ferreux",
  "24.46Y": "Élaboration et transformation de matières nucléaires",
  "24.51Y": "Fonderie de fonte",
  "24.52Y": "Fonderie d’acier",
  "24.53Y": "Fonderie de métaux légers",
  "24.54Y": "Fonderie d’autres métaux non ferreux",
  "25.11Y": "Fabrication de structures métalliques et de parties de structures",
  "25.12Y": "Fabrication de portes et fenêtres en métal",
  "25.21Y": "Fabrication de radiateurs et de chaudières pour le chauffage central",
  "25.22Y": "Fabrication d’autres réservoirs, citernes et conteneurs métalliques",
  "25.30Y": "Fabrication d’armes et de munitions",
  "25.40Y": "Forgeage et façonnage de métal ; métallurgie des poudres",
  "25.51Y": "Revêtement des métaux",
  "25.52Y": "Traitement thermique des métaux",
  "25.53Y": "Usinage des métaux",
  "25.61Y": "Fabrication de coutellerie",
  "25.62Y": "Fabrication de serrures et de ferrures",
  "25.63Y": "Fabrication d’outillage",
  "25.91Y": "Fabrication de fûts et emballages métalliques similaires",
  "25.92Y": "Fabrication d’emballages métalliques légers",
  "25.93Y": "Fabrication d’articles en fils métalliques, de chaînes et de ressorts",
  "25.94Y": "Fabrication de vis et de boulons",
  "25.99Y": "Fabrication d’autres produits métalliques n.c.a.",
  "26.11Y": "Fabrication de composants électroniques",
  "26.12Y": "Fabrication de cartes électroniques assemblées",
  "26.20Y": "Fabrication d’ordinateurs et d’équipements périphériques",
  "26.30Y": "Fabrication d’équipements de communication",
  "26.40Y": "Fabrication de produits électroniques grand public",
  "26.51Y": "Fabrication d’instruments et d’appareils de mesure, d’essai et de navigation",
  "26.52Y": "Horlogerie",
  "26.60Y": "Fabrication d’équipements d’irradiation médicale, d’équipements électromédicaux et électrothérapeutiques",
  "26.70Y": "Fabrication de matériels optique et photographique et de supports magnétiques et optiques",
  "27.11Y": "Fabrication de moteurs, génératrices et transformateurs électriques",
  "27.12Y": "Fabrication de matériel de distribution et de commande électrique",
  "27.20Y": "Fabrication de piles et d’accumulateurs électriques",
  "27.31Y": "Fabrication de câbles de fibres optiques",
  "27.32Y": "Fabrication d’autres fils et câbles électroniques ou électriques",
  "27.33Y": "Fabrication de matériel d’installation électrique",
  "27.40Y": "Fabrication d’appareils d’éclairage",
  "27.51Y": "Fabrication d’appareils électroménagers",
  "27.52Y": "Fabrication d’appareils ménagers non électriques",
  "27.90Y": "Fabrication d’autres matériels électriques",
  "28.11Y": "Fabrication de moteurs et turbines, à l’exception des moteurs d’avions et de véhicules",
  "28.12Y": "Fabrication d’équipements de transmission de puissance hydrauliques et pneumatiques",
  "28.13G": "Fabrication d'autres pompes",
  "28.13H": "Fabrication d'autres compresseurs",
  "28.14Y": "Fabrication d’autres articles de robinetterie",
  "28.15Y": "Fabrication de roulements et de transmissions mécaniques",
  "28.21Y": "Fabrication de fours et brûleurs et d’équipements fixes de chauffage domestique",
  "28.22Y": "Fabrication de matériel de levage et de manutention",
  "28.23Y": "Fabrication de machines et d’équipements de bureau (à l’exception des ordinateurs et équipements périphériques)",
  "28.24Y": "Fabrication d’outillage portatif à moteur incorporé",
  "28.25Y": "Fabrication d’équipements aérauliques et frigorifiques industriels",
  "28.29Y": "Fabrication de machines diverses d’usage général",
  "28.30Y": "Fabrication de machines agricoles et forestières",
  "28.41Y": "Fabrication de machines-outils pour le formage et le travail des métaux",
  "28.42Y": "Fabrication d’autres machines-outils",
  "28.91Y": "Fabrication de machines pour la métallurgie",
  "28.92Y": "Fabrication de machines pour l’extraction ou la construction",
  "28.93Y": "Fabrication de machines pour l’industrie agro-alimentaire",
  "28.94Y": "Fabrication de machines pour les industries textiles et du cuir",
  "28.95Y": "Fabrication de machines pour les industries du papier et du carton",
  "28.96Y": "Fabrication de machines pour le travail du caoutchouc ou des plastiques",
  "28.97Y": "Fabrication de machines de fabrication additive",
  "28.99Y": "Fabrication d’autres machines d’usage spécifique n.c.a.",
  "29.10Y": "Construction de véhicules automobiles",
  "29.20Y": "Fabrication de carrosseries de véhicules automobiles ; fabrication de remorques et de semi-remorques",
  "29.31Y": "Fabrication d’équipements électriques et électroniques automobiles",
  "29.32Y": "Fabrication d’autres équipements automobiles",
  "30.11Y": "Construction de navires et de structures flottantes civiles",
  "30.12Y": "Construction de bateaux de plaisance",
  "30.13Y": "Construction de bateaux et navires militaires",
  "30.20Y": "Construction de locomotives et d’autre matériel ferroviaire roulant",
  "30.31Y": "Construction aéronautique et spatiale civile",
  "30.32Y": "Construction aéronautique et spatiale militaire",
  "30.40Y": "Construction de véhicules militaires de combat",
  "30.91Y": "Fabrication de motocycles",
  "30.92Y": "Fabrication de bicyclettes et de véhicules pour invalides",
  "30.99Y": "Fabrication d’autres équipements de transport n.c.a.",
  "31.00G": "Fabrication de meubles à destination de professionnels",
  "31.00H": "Fabrication de meubles de cuisine et salle de bain",
  "31.00J": "Fabrication d'autres meubles domestiques, de sommiers et de matelas",
  "32.11Y": "Frappe de monnaie",
  "32.12Y": "Fabrication d’articles de joaillerie et bijouterie",
  "32.13Y": "Fabrication d’articles de bijouterie fantaisie et articles similaires",
  "32.20Y": "Fabrication d’instruments de musique",
  "32.30Y": "Fabrication d’articles de sport",
  "32.40Y": "Fabrication de jeux et jouets",
  "32.50Y": "Fabrication d’instruments et de fournitures à usage médical et dentaire",
  "32.91Y": "Fabrication d’articles de brosserie",
  "32.99Y": "Autres activités manufacturières n.c.a.",
  "33.11Y": "Réparation et entretien d’ouvrages en métaux",
  "33.12Y": "Réparation et entretien de machines",
  "33.13Y": "Réparation et entretien de matériels électroniques et optiques",
  "33.14Y": "Réparation et entretien d’équipements électriques",
  "33.15Y": "Réparation et entretien de bateaux et navires civils",
  "33.16Y": "Réparation et entretien d’aéronefs et d’engins spatiaux civils",
  "33.17Y": "Réparation et entretien d’autres équipements de transport civils",
  "33.18G": "Réparation et entretien d’aéronefs et d’engins spatiaux militaires",
  "33.18H": "Réparation et entretien de véhicules de combat, de navires et de bateaux militaires",
  "33.19Y": "Réparation et entretien d’autres équipements",
  "33.20Y": "Installation de machines et d’équipements industriels",
  "35.11Y": "Production d’électricité à partir de sources non renouvelables",
  "35.12Y": "Production d’électricité à partir de sources renouvelables",
  "35.13Y": "Transport d’électricité",
  "35.14Y": "Distribution d’électricité",
  "35.15G": "Exploitation d'installations de recharge pour véhicules électriques",
  "35.15H": "Autre commerce d’électricité",
  "35.16Y": "Stockage de l’électricité",
  "35.21Y": "Production de gaz",
  "35.22Y": "Distribution de combustibles gazeux par conduites",
  "35.23Y": "Commerce de combustibles gazeux par conduites",
  "35.24Y": "Stockage de gaz dans le cadre de services d’approvisionnement en réseau",
  "35.30Y": "Production et distribution de vapeur et d’air conditionné",
  "35.40Y": "Activités des courtiers et agents pour l’électricité et le gaz naturel",
  "36.00Y": "Captage, traitement et distribution d’eau",
  "37.00Y": "Collecte et traitement des eaux usées",
  "38.11Y": "Collecte des déchets non dangereux",
  "38.12Y": "Collecte des déchets dangereux",
  "38.21Y": "Récupération de matériaux",
  "38.22Y": "Valorisation énergétique",
  "38.23Y": "Autre valorisation des déchets",
  "38.31Y": "Incinération sans récupération d’énergie",
  "38.32Y": "Mise en décharge ou stockage permanent",
  "38.33Y": "Autre élimination des déchets",
  "39.00Y": "Activités de dépollution et autres activités de service de gestion des déchets",
  "41.00G": "Construction de maisons individuelles",
  "41.00H": "Construction d'autres bâtiments",
  "42.11Y": "Construction de routes et autoroutes",
  "42.12Y": "Construction de voies ferrées de surface et souterraines",
  "42.13G": "Construction de ponts et de viaducs",
  "42.13H": "Construction de tunnels",
  "42.21Y": "Construction de réseaux pour fluides",
  "42.22Y": "Construction de réseaux électriques et de télécommunications",
  "42.91Y": "Construction d’ouvrages maritimes et fluviaux",
  "42.99Y": "Construction d’autres ouvrages de génie civil n.c.a.",
  "43.11Y": "Démolition",
  "43.12G": "Travaux de terrassement courants et travaux préparatoires",
  "43.12H": "Travaux de terrassement spécialisés ou de grande masse",
  "43.13Y": "Forages et sondages",
  "43.21G": "Travaux d'installation électrique dans tous locaux",
  "43.21H": "Travaux d'installation électrique sur la voie",
  "43.22G": "Travaux d'installation d'eau et de gaz en tous locaux",
  "43.22H": "Travaux d'installation d'équipements thermiques et de climatisation",
  "43.23Y": "Mise en place de l’isolation",
  "43.24Y": "Autres travaux d’installation",
  "43.31Y": "Travaux de plâtrerie",
  "43.32G": "Travaux de menuiserie bois et PVC",
  "43.32H": "Travaux de menuiserie métallique",
  "43.33Y": "Travaux de revêtement des sols et des murs",
  "43.34G": "Travaux de peinture",
  "43.34H": "Travaux de vitrerie",
  "43.35Y": "Autres travaux de finition",
  "43.41G": "Travaux de charpente",
  "43.41H": "Travaux de couverture par éléments",
  "43.41J": "Travaux d'étanchéification pour la toiture",
  "43.42G": "Travaux de montage d’éléments de construction préfabriqués pour bâtiments, en acier",
  "43.42H": "Travaux de montage d’éléments de construction préfabriqués pour bâtiments, en bois",
  "43.42J": "Autres travaux de construction spécialisés dans la construction de bâtiments n.c.a.",
  "43.50Y": "Travaux de construction spécialisés en génie civil",
  "43.60Y": "Activités de service d’intermédiation pour des travaux de construction spécialisés",
  "43.91Y": "Travaux de maçonnerie et de pose de briques",
  "43.99G": "Location avec opérateur d’équipement de construction",
  "43.99H": "Tous les autres travaux de construction spécialisés n.c.a.",
  "46.11Y": "Activités d’intermédiaire du commerce de gros en matières premières agricoles, animaux vivants, matières premières textiles et produits semi-finis",
  "46.12Y": "Activités d’intermédiaire du commerce de gros en combustibles, minerais, métaux et produits chimiques",
  "46.13Y": "Activités d’intermédiaire du commerce de gros en bois et matériaux de construction",
  "46.14Y": "Activités d’intermédiaire du commerce de gros en machines, équipements industriels, navires et avions",
  "46.15Y": "Activités d’intermédiaire du commerce de gros en meubles, biens domestiques et quincaillerie",
  "46.16Y": "Activités d’intermédiaire du commerce de gros en textiles, habillement, fourrures, chaussures et articles en cuir",
  "46.17G": "Activités d’intermédiation des centrales d’achat alimentaires",
  "46.17H": "Autres activités d'intermédiaire du commerce de gros en denrées, boissons et tabac",
  "46.18Y": "Activités d’intermédiaire spécialisé dans le commerce de gros d’autres produits spécifiques",
  "46.19G": "Activités d’intermédiation des centrales d’achat non spécialisées",
  "46.19H": "Autres activités d'intermédiaire non spécialisé du commerce de gros",
  "46.21Y": "Commerce de gros de céréales, de tabac non manufacturé, de semences et d’aliments pour animaux",
  "46.22Y": "Commerce de gros de fleurs et de plantes",
  "46.23Y": "Commerce de gros d’animaux vivants",
  "46.24Y": "Commerce de gros de cuirs et de peaux",
  "46.31Y": "Commerce de gros de fruits et légumes",
  "46.32G": "Commerce de gros de viandes et de produits à base de viande",
  "46.32H": "Commerce de gros de poissons, crustacés et mollusques et de produits à base de poisson",
  "46.33Y": "Commerce de gros de produits laitiers, œufs, huiles et matières grasses comestibles",
  "46.34Y": "Commerce de gros de boissons",
  "46.35Y": "Commerce de gros de produits à base de tabac",
  "46.36Y": "Commerce de gros de sucre, chocolat et confiserie",
  "46.37Y": "Commerce de gros de café, thé, cacao et épices",
  "46.38Y": "Commerce de gros d’autres denrées alimentaires",
  "46.39Y": "Commerce de gros non spécialisé de denrées, boissons et tabac",
  "46.41Y": "Commerce de gros de textiles",
  "46.42Y": "Commerce de gros d’habillement et de chaussures",
  "46.43G": "Commerce de gros d’appareils de génie climatique",
  "46.43H": "Commerce de gros d’autres appareils électroménagers",
  "46.44Y": "Commerce de gros de vaisselle, verrerie et produits d’entretien",
  "46.45Y": "Commerce de gros de parfumerie et de produits de beauté",
  "46.46Y": "Commerce de gros de produits pharmaceutiques et médicaux",
  "46.47Y": "Commerce de gros de meubles à usage domestique, de bureau et de magasin, de tapis et d’appareils d’éclairage",
  "46.48Y": "Commerce de gros d’articles d’horlogerie et de bijouterie",
  "46.49Y": "Commerce de gros d’autres biens domestiques",
  "46.50Y": "Commerce de gros d’équipements de l’information et de la communication",
  "46.61Y": "Commerce de gros de matériel agricole",
  "46.62Y": "Commerce de gros de machines-outils",
  "46.63Y": "Commerce de gros de machines pour l’extraction, la construction et le génie civil",
  "46.64G": "Commerce de gros d’autre matériel électrique",
  "46.64H": "Commerce de gros de matériels de manutention et de levage",
  "46.64J": "Commerce de gros d’autres machines et équipements pour l’industrie et le transport",
  "46.64K": "Commerce de gros d’autres machines et équipements pour le commerce et les services",
  "46.71G": "Commerce de gros de véhicules automobiles légers (moins de 3,5 tonnes)",
  "46.71H": "Commerce de gros d’autres véhicules automobiles",
  "46.72Y": "Commerce de gros de pièces et accessoires de véhicules automobiles",
  "46.73Y": "Commerce de gros de motocycles et de pièces et accessoires pour motocycles",
  "46.81Y": "Commerce de gros de combustibles solides, liquides et gazeux et de produits annexes",
  "46.82Y": "Commerce de gros de minerais et de métaux",
  "46.83G": "Commerce de gros de bois et matériaux de construction",
  "46.83H": "Commerce de gros d’appareils sanitaires",
  "46.83J": "Commerce de gros de matériaux de décoration",
  "46.84G": "Commerce de gros de quincaillerie et de matériel de bricolage",
  "46.84H": "Commerce de gros de fournitures pour plomberie et chauffage",
  "46.85Y": "Commerce de gros de produits chimiques",
  "46.86Y": "Commerce de gros d’autres produits intermédiaires",
  "46.87Y": "Commerce de gros de déchets et débris",
  "46.89Y": "Autre commerce de gros spécialisé n.c.a.",
  "46.90Y": "Commerce de gros non spécialisé",
  "47.11G": "Commerce de détail non spécialisé à prédominance alimentaire en magasin de moins de 120 m²",
  "47.11H": "Commerce de détail non spécialisé à prédominance alimentaire en magasin de 120 à 400 m² (supérette)",
  "47.11J": "Commerce de détail non spécialisé à prédominance alimentaire en magasin de 400 à 2500 m² (supermarché)",
  "47.11K": "Commerce de détail non spécialisé à prédominance alimentaire en magasin de plus de 2500 m² (hypermarché)",
  "47.11L": "Commerce de détail non spécialisé à prédominance alimentaire hors magasin",
  "47.12G": "Autre commerce de détail non spécialisé en magasin de plus de 2500 m² (grand magasin)",
  "47.12H": "Autre commerce de détail non spécialisé en magasin de moins de 2500 m² ou hors magasin",
  "47.21Y": "Commerce de détail de fruits et légumes",
  "47.22Y": "Commerce de détail de viande et de produits à base de viande",
  "47.23Y": "Commerce de détail de poisson, de crustacés et de mollusques",
  "47.24Y": "Commerce de détail de pain, de pâtisserie et de confiserie",
  "47.25Y": "Commerce de détail de boissons",
  "47.26Y": "Commerce de détail de produits à base de tabac",
  "47.27G": "Commerce de détail de produits laitiers et d'œufs",
  "47.27H": "Commerce de détail spécialisé d’autres produits d’épicerie et d’autres produits alimentaires n.c.a.",
  "47.30Y": "Commerce de détail de carburants",
  "47.40Y": "Commerce de détail d’équipements de l’information et de la communication",
  "47.51Y": "Commerce de détail de textiles",
  "47.52G": "Commerce de détail de quincaillerie, de matériaux de construction et de bricolage, de peinture et de verre en magasin de moins de 400 m²",
  "47.52H": "Commerce de détail de quincaillerie, de matériaux de construction et de bricolage, de peinture et de verre en magasin de plus de 400 m² ou hors magasin",
  "47.53Y": "Commerce de détail de tapis, moquettes et revêtements de murs et de sols",
  "47.54Y": "Commerce de détail d’appareils électroménagers",
  "47.55G": "Commerce de détail de meubles",
  "47.55H": "Commerce de détail d'appareils d’éclairage, de vaisselle et d’autres équipements du foyer",
  "47.61Y": "Commerce de détail de livres",
  "47.62Y": "Commerce de détail de journaux et autres publications périodiques et de papeterie",
  "47.63Y": "Commerce de détail d’articles de sport",
  "47.64Y": "Commerce de détail de jeux et jouets",
  "47.69Y": "Commerce de détail de biens culturels et de loisirs n.c.a.",
  "47.71Y": "Commerce de détail d’habillement",
  "47.72G": "Commerce de détail de chaussures",
  "47.72H": "Commerce de détail de maroquinerie et d'articles de voyage",
  "47.73Y": "Commerce de détail de produits pharmaceutiques",
  "47.74G": "Commerce de détail d'optique",
  "47.74H": "Commerce de détail d’autres articles médicaux et orthopédiques",
  "47.75Y": "Commerce de détail de parfumerie et de produits de beauté",
  "47.76Y": "Commerce de détail de fleurs, plantes, engrais, animaux de compagnie et aliments pour ces animaux",
  "47.77Y": "Commerce de détail d’articles d’horlogerie et de bijouterie",
  "47.78G": "Commerce de détail de charbons et combustibles",
  "47.78H": "Commerce de détail spécialisé d’autres biens neufs n.c.a.",
  "47.79G": "Commerce de détail d’antiquités et livres anciens",
  "47.79H": "Commerce de détail d’autres biens d’occasion",
  "47.81Y": "Commerce de détail de véhicules automobiles",
  "47.82Y": "Commerce de détail de pièces et accessoires de véhicules automobiles",
  "47.83Y": "Commerce de détail de motocycles et de pièces et accessoires de motocycles",
  "47.91Y": "Activités de service d’intermédiation pour le commerce de détail non spécialisé",
  "47.92G": "Activités de service d’intermédiation pour le commerce de détail de véhicules automobiles",
  "47.92H": "Activités de service d’intermédiation pour le commerce de détail de journaux et de produits à base de tabac",
  "47.92J": "Activités de service d'intermédiation pour le commerce de détail spécialisé d’autres biens",
  "49.11Y": "Transport ferroviaire lourd de voyageurs",
  "49.12Y": "Autre transport ferroviaire de voyageurs",
  "49.20Y": "Transport ferroviaire de fret",
  "49.31G": "Transport régulier urbain et suburbain de voyageurs par route",
  "49.31H": "Autre transport régulier de voyageurs par route",
  "49.32Y": "Transport non régulier de voyageurs par route",
  "49.33G": "Transport de personnes par taxi",
  "49.33H": "Autre transport de personnes sur demande par véhicule avec chauffeur",
  "49.34Y": "Transport de voyageurs par téléphériques et remontées mécaniques",
  "49.39Y": "Autre transport terrestre de voyageurs n.c.a.",
  "49.41G": "Transport routier de fret longue distance",
  "49.41H": "Transport routier de fret régional et de proximité",
  "49.41J": "Location de camions avec chauffeur",
  "49.42Y": "Services de déménagement",
  "49.50Y": "Transport par conduites",
  "50.10Y": "Transports maritimes et côtiers de passagers",
  "50.20Y": "Transports maritimes et côtiers de fret",
  "50.30Y": "Transports fluviaux de passagers",
  "50.40Y": "Transports fluviaux de fret",
  "51.10Y": "Transports aériens de passagers",
  "51.21Y": "Transports aériens de fret",
  "51.22Y": "Transports spatiaux",
  "52.10G": "Entreposage et stockage frigorifique",
  "52.10H": "Entreposage et stockage non frigorifique",
  "52.21Y": "Services auxiliaires des transports terrestres",
  "52.22Y": "Services auxiliaires des transports par eau",
  "52.23Y": "Services auxiliaires des transports aériens",
  "52.24G": "Manutention portuaire",
  "52.24H": "Manutention non portuaire",
  "52.25Y": "Activités de service logistique",
  "52.26Y": "Autres activités de soutien pour les transports",
  "52.31Y": "Activités de service d’intermédiation pour le transport de fret",
  "52.32Y": "Activités de service d’intermédiation pour le transport de passagers",
  "53.10Y": "Activités de poste dans le cadre d’une obligation de service universel",
  "53.20G": "Livraison de colis",
  "53.20H": "Livraison à domicile de repas et autres activités de poste et de courrier n.c.a.",
  "53.30Y": "Activités de service d’intermédiation pour des activités de poste et de courrier",
  "55.10Y": "Hôtels et hébergement similaire",
  "55.20Y": "Hébergement touristique et autre hébergement de courte durée",
  "55.30Y": "Terrains de camping et parcs pour caravanes ou véhicules de loisirs",
  "55.40Y": "Activités de service d’intermédiation pour l’hébergement",
  "55.90Y": "Autres hébergements",
  "56.11G": "Restauration traditionnelle",
  "56.11H": "Cafétérias et autres libres services",
  "56.11J": "Restauration de type rapide",
  "56.12Y": "Activités de service de restauration mobile",
  "56.21Y": "Activités de traiteur événementiel",
  "56.22Y": "Activités de service contractuel de restauration et autres activités de service de restauration",
  "56.30Y": "Activités de débit de boissons",
  "56.40Y": "Activités de service d’intermédiation pour des activités de service de restauration",
  "58.11Y": "Édition de livres",
  "58.12Y": "Édition de journaux",
  "58.13Y": "Édition de revues et de périodiques",
  "58.19Y": "Autres activités d’édition, à l’exception de l’édition de logiciels",
  "58.21Y": "Édition de jeux vidéo",
  "58.29Y": "Édition d’autres logiciels",
  "59.11G": "Production de films et programmes audiovisuels",
  "59.11H": "Production de films institutionnels et publicitaires",
  "59.11J": "Production de films pour le cinéma",
  "59.11K": "Production de films et programmes d'animation",
  "59.12Y": "Post-production de films cinématographiques, de vidéos et de programmes de télévision",
  "59.13Y": "Distribution de films cinématographiques et de vidéos",
  "59.14Y": "Projection de films cinématographiques",
  "59.20Y": "Enregistrement sonore et édition musicale",
  "60.10Y": "Radiodiffusion et activités de distribution de contenu audio",
  "60.20G": "Programmation de télévision et télédiffusion",
  "60.20H": "Édition de services de médias à la demande",
  "60.31Y": "Activités d’agence de presse",
  "60.39Y": "Autres activités de distribution de contenu",
  "61.10Y": "Activités de télécommunications filaires, sans fil et satellitaires",
  "61.20Y": "Activités de revente de télécommunications et activités de service d’intermédiation pour les télécommunications",
  "61.90Y": "Autres activités de télécommunications",
  "62.10Y": "Activités de programmation informatique",
  "62.20G": "Conseil en systèmes et logiciels informatiques",
  "62.20H": "Gestion d'installations informatiques et maintenance de systèmes et d’applications informatiques",
  "62.90Y": "Autres activités de service informatique",
  "63.10Y": "Infrastructure informatique, traitement de données, hébergement et activités connexes",
  "63.91Y": "Activités de portail de recherche sur le web",
  "63.92Y": "Autres activités de service d’information",
  "64.11Y": "Activités de banque centrale",
  "64.19Y": "Autre intermédiation monétaire",
  "64.21Y": "Activités de société holding",
  "64.22Y": "Activités de conduit de financement",
  "64.31Y": "Activités de fonds d’investissement sur le marché monétaire ou non monétaire",
  "64.32Y": "Activités de fiducie, comptes de patrimoine et d’agence",
  "64.91Y": "Crédit-bail",
  "64.92Y": "Autre distribution de crédit",
  "64.99Y": "Autres activités des services financiers, hors assurance et fonds de pension, n.c.a.",
  "65.11Y": "Assurance vie",
  "65.12Y": "Assurances non-vie",
  "65.20Y": "Réassurance",
  "65.30Y": "Fonds de pension",
  "66.11Y": "Administration de marchés financiers",
  "66.12Y": "Courtage de valeurs mobilières et de matières premières",
  "66.19G": "Activités des unités non productives détentrices de patrimoine mobilier",
  "66.19H": "Autres activités auxiliaires de services financiers, hors assurance et caisses de retraite, n.c.a.",
  "66.21Y": "Évaluation des risques et dommages",
  "66.22Y": "Activités des agents et courtiers d’assurances",
  "66.29Y": "Activités auxiliaires d’assurance et de fonds de pension n.c.a.",
  "66.30Y": "Activités de gestion de fonds",
  "68.11Y": "Achat et vente de biens propres",
  "68.12Y": "Promotion immobilière",
  "68.20G": "Location de logements",
  "68.20H": "Location et exploitation d'autres biens immobiliers propres ou loués",
  "68.31Y": "Activités de service d’intermédiation pour les activités immobilières",
  "68.32G": "Activités des unités non productives détentrices de patrimoine immobilier",
  "68.32H": "Autres activités immobilières pour compte de tiers n.c.a.",
  "69.10Y": "Activités juridiques",
  "69.20Y": "Activités de comptabilité, de tenue de comptes et d’audit ; conseil fiscal",
  "70.10Y": "Activités des sièges sociaux",
  "70.20Y": "Activités de conseil pour les affaires et autre conseil de gestion",
  "71.11Y": "Activités d’architecture",
  "71.12Y": "Activités d’ingénierie et de conseil technique connexe",
  "71.20G": "Contrôle technique des véhicules",
  "71.20H": "Analyses, essais et inspections techniques",
  "72.10G": "Recherche et développement en biotechnologies",
  "72.10H": "Recherche et développement en autres sciences physiques et naturelles",
  "72.20Y": "Recherche et développement en sciences humaines et sociales",
  "73.11Y": "Activités d’agence de publicité",
  "73.12Y": "Régie publicitaire de médias",
  "73.20Y": "Études de marché et sondages",
  "73.30Y": "Activités de relations publiques et de communication",
  "74.11Y": "Activités de design pour la création de mode ou les produits industriels",
  "74.12Y": "Activités de design graphique et de communication visuelle",
  "74.13Y": "Activités de design d’intérieur",
  "74.14Y": "Autres activités spécialisées de design",
  "74.20Y": "Activités photographiques",
  "74.30Y": "Activités de traduction et d’interprétation",
  "74.91Y": "Activités de courtage et de marketing de brevets",
  "74.99Y": "Toutes les autres activités spécialisées, scientifiques et techniques n.c.a.",
  "75.00Y": "Activités vétérinaires",
  "77.11Y": "Location et location-bail de voitures et véhicules automobiles légers",
  "77.12Y": "Location et location-bail de camions",
  "77.21Y": "Location et location-bail d’articles de loisirs et de sport",
  "77.22Y": "Location et location-bail d’autres biens personnels et domestiques",
  "77.31Y": "Location et location-bail de matériel agricole",
  "77.32Y": "Location et location-bail de machines et équipements pour la construction et le génie civil",
  "77.33Y": "Location et location-bail de machines et équipements de bureau et d’ordinateurs",
  "77.34Y": "Location et location-bail de matériels de transport par eau",
  "77.35Y": "Location et location-bail de matériels de transport aérien",
  "77.39Y": "Location et location-bail d’autres machines, équipements et biens n.c.a.",
  "77.40G": "Services de franchise ou de licence de marques",
  "77.40H": "Autre location-bail de propriété intellectuelle et de produits similaires, à l'exception des œuvres soumises à copyright",
  "77.51Y": "Activités de service d’intermédiation pour la location et la location-bail de voitures, camping-cars et caravanes",
  "77.52Y": "Activités de service d’intermédiation pour la location et la location-bail d’autres biens corporels et d’immobilisations incorporelles non financières",
  "78.10Y": "Activités des agences de placement de main-d’œuvre",
  "78.20G": "Activités d’agence de travail temporaire",
  "78.20H": "Autre mise à disposition de ressources humaines",
  "79.11Y": "Activités d’agence de voyage",
  "79.12Y": "Activités de voyagiste",
  "79.90Y": "Autres activités de service de réservation et activités connexes",
  "80.01Y": "Activités d’investigation et de sécurité privée",
  "80.09Y": "Activités de sécurité n.c.a.",
  "81.10Y": "Activités de soutien combinées pour les installations",
  "81.21Y": "Nettoyage courant des bâtiments",
  "81.22Y": "Autres activités de nettoyage des bâtiments et nettoyage industriel",
  "81.23G": "Désinfection, désinsectisation, dératisation",
  "81.23H": "Autres activités de nettoyage n.c.a.",
  "81.30Y": "Activités de service d’aménagement paysager",
  "82.10Y": "Activités de service de bureau et de soutien administratif",
  "82.20Y": "Activités de centre d’appels",
  "82.30Y": "Organisation de salons professionnels et congrès",
  "82.40Y": "Activités de service d’intermédiation pour des services de soutien aux entreprises n.c.a.",
  "82.91Y": "Activités d’agence de recouvrement et de bureau de crédit",
  "82.92Y": "Activités de conditionnement",
  "82.99Y": "Autres activités de service de soutien aux entreprises n.c.a.",
  "84.11Y": "Activités d’administration publique générale",
  "84.12Y": "Réglementation des soins de santé, de l’enseignement, des services culturels et des autres services sociaux",
  "84.13Y": "Réglementation et contribution à l’amélioration de l’efficacité des activités économiques",
  "84.21Y": "Affaires étrangères",
  "84.22Y": "Défense",
  "84.23Y": "Justice",
  "84.24Y": "Activités d’ordre public et de sécurité civile",
  "84.25Y": "Activités de service d’incendie et de secours",
  "84.30G": "Activités générales de sécurité sociale",
  "84.30H": "Gestion des retraites complémentaires",
  "84.30J": "Distribution sociale de revenus",
  "85.10Y": "Enseignement pré-primaire",
  "85.20Y": "Enseignement primaire",
  "85.31Y": "Enseignement secondaire général",
  "85.32Y": "Enseignement secondaire professionnel",
  "85.33Y": "Enseignement post-secondaire non supérieur",
  "85.40Y": "Enseignement supérieur",
  "85.51Y": "Enseignement de disciplines sportives et d’activités de loisirs",
  "85.52Y": "Enseignement culturel",
  "85.53Y": "Enseignement de la conduite",
  "85.59G": "Formation continue d'adultes",
  "85.59H": "Tous les autres enseignements n.c.a.",
  "85.61Y": "Activités de service d’intermédiation dans le domaine de l’appui scolaire et du tutorat",
  "85.69Y": "Activités de soutien à l’enseignement n.c.a.",
  "86.10Y": "Activités hospitalières",
  "86.21Y": "Activités de médecine générale",
  "86.22Y": "Activités de médecine spécialisée",
  "86.23Y": "Activités de soins dentaires",
  "86.91Y": "Activités d’imagerie médicale et de laboratoire d’analyse médicale",
  "86.92Y": "Transport de patients par ambulance",
  "86.93Y": "Activités des psychologues et psychothérapeutes, à l’exception des médecins",
  "86.94G": "Activités de soins infirmiers",
  "86.94H": "Activités de maïeutique",
  "86.95Y": "Activités de physiothérapie",
  "86.96Y": "Activités de médecine traditionnelle, complémentaire et alternative",
  "86.97Y": "Activités de service d’intermédiation pour les services médicaux, dentaires et autres services pour la santé humaine",
  "86.99Y": "Autres activités pour la santé humaine n.c.a.",
  "87.10G": "Activités d’hébergement médicalisé pour personnes âgées",
  "87.10H": "Activités d’hébergement médicalisé pour enfants en situation de handicap",
  "87.10J": "Activités d’hébergement médicalisé pour adultes en situation de handicap et autres activités d’hébergement médicalisé",
  "87.20G": "Activités d’hébergement social pour personnes souffrant de maladie mentale",
  "87.20H": "Activités d’hébergement social pour personnes souffrant de toxicomanie",
  "87.30G": "Activités d’hébergement social pour personnes âgées",
  "87.30H": "Activités d’hébergement social pour personnes en situation de handicap physique",
  "87.91Y": "Activités de service d’intermédiation pour des activités de soins en établissement résidentiel",
  "87.99G": "Activités d’hébergement social pour enfants en difficulté",
  "87.99H": "Activités d’hébergement social pour adultes et familles en difficulté et autres activités d’hébergement social n.c.a.",
  "88.10G": "Activités d’action sociale à domicile",
  "88.10H": "Activités d’accueil ou d’accompagnement sans hébergement d’adultes en situation de handicap ou de personnes âgées",
  "88.10J": "Activités de réadaptation professionnelle et réinsertion, aide par le travail",
  "88.91G": "Accueil de jeunes enfants en structure collective",
  "88.91H": "Accueil de jeunes enfants à domicile",
  "88.91J": "Accueil ou accompagnement sans hébergement d’enfants en situation de handicap",
  "88.99G": "Autre accueil ou accompagnement sans hébergement d’enfants et d’adolescents",
  "88.99H": "Toutes les autres activités d’action sociale sans hébergement n.c.a.",
  "90.11Y": "Activités de création littéraire et de composition musicale",
  "90.12Y": "Activités de création en arts visuels",
  "90.13Y": "Autres activités de création artistique",
  "90.20Y": "Activités de spectacle",
  "90.31G": "Gestion d’installations et de lieux de production et de diffusion des arts visuels",
  "90.31H": "Gestion de salles de spectacle vivant",
  "90.39G": "Activités de production et organisation d'évènements culturels",
  "90.39H": "Activités de soutien technique aux spectacles et aux événements culturels",
  "91.11Y": "Activités des bibliothèques",
  "91.12Y": "Activités des centres d’archives",
  "91.21Y": "Activités des musées et collections",
  "91.22Y": "Activité des monuments et sites historiques",
  "91.30Y": "Conservation, restauration et autres activités de soutien pour la préservation du patrimoine culturel",
  "91.41Y": "Activités de gestion de jardins botaniques et zoologiques",
  "91.42Y": "Activités de gestion de réserves naturelles",
  "92.00Y": "Activités de jeux d’argent et de paris",
  "93.11Y": "Gestion d’installations sportives",
  "93.12Y": "Activités des clubs de sports",
  "93.13Y": "Activités des centres de fitness",
  "93.19Y": "Autres activités sportives n.c.a.",
  "93.21Y": "Activités des parcs d’attractions et parcs à thème",
  "93.29Y": "Activités récréatives et de loisirs n.c.a.",
  "94.11Y": "Activités des organisations patronales et des chambres représentatives",
  "94.12Y": "Activités des organisations professionnelles",
  "94.20Y": "Activités des syndicats de salariés",
  "94.91Y": "Activités des organisations religieuses",
  "94.92Y": "Activités des organisations politiques",
  "94.99Y": "Activités des organisations associatives n.c.a.",
  "95.10Y": "Réparation et entretien d’ordinateurs et d’équipements de communication",
  "95.21Y": "Réparation et entretien de produits électroniques grand public",
  "95.22Y": "Réparation et entretien d’appareils électroménagers et d’équipements pour la maison et le jardin",
  "95.23Y": "Réparation et entretien de chaussures et d’articles en cuir",
  "95.24Y": "Réparation et entretien de meubles et d’équipements du foyer",
  "95.25Y": "Réparation et entretien d’articles d’horlogerie et de bijouterie",
  "95.29G": "Réparation et entretien de cycles et autres engins de la mobilité douce",
  "95.29H": "Réparation et entretien de tous les autres biens personnels ou domestiques n.c.a.",
  "95.31G": "Réparation et entretien de véhicules automobiles légers (moins de 3,5 tonnes)",
  "95.31H": "Réparation et entretien d'autres véhicules automobiles",
  "95.32Y": "Réparation et entretien de motocycles",
  "95.40Y": "Activités de service d’intermédiation pour la réparation et l’entretien d’ordinateurs, de biens personnels et domestiques et d’automobiles et motocycles",
  "96.10G": "Blanchisserie-teinturerie de gros",
  "96.10H": "Blanchisserie-teinturerie de détail",
  "96.21G": "Coiffure et activités de barbier en salon",
  "96.21H": "Coiffure et activités de barbier hors salon",
  "96.22Y": "Soins de beauté et autres activités de traitement esthétique",
  "96.23Y": "Activités de spa, de sauna et de bain de vapeur",
  "96.30Y": "Services funéraires et activités connexes",
  "96.40Y": "Activités de service d’intermédiation pour des services aux personnes",
  "96.91Y": "Activités d’offre de services domestiques aux personnes",
  "96.99G": "Services pour animaux de compagnie",
  "96.99H": "Toutes les autres activités de service aux personnes n.c.a.",
  "97.00Y": "Activités des ménages en tant qu’employeurs de personnel domestique",
  "98.10Y": "Activités indifférenciées des ménages en tant que producteurs de biens pour usage propre",
  "98.20Y": "Activités indifférenciées des ménages en tant que producteurs de services pour usage propre",
  "99.00Y": "Activités des organisations et organismes extraterritoriaux",
};
